<template>
  <div class="container h-100 p-5 position-absolute login-container">
    <div class="row h-100">
      <!-- <div class="col-12 offset-1 p-0">
        <div class="alert alert-warning col-10 p-3 text-center">
          <h3 for="email" class="mr-auto text-dark font-weight-bolder p-0 m-0">Ventana de mantenimieto</h3></br>
          <div class="text-center text-dark ">
            Estimado servidor público, el sistema de declaración patrimonial estará en matenimiento este martes 27 de abril a partir de las 12 p.m. y hasta las 3 p.m.
          </div>
        </div>
      </div> -->
      <div class="col-md-10 col-sm-10 offset-md-1 offset-sm-1 overflow-hidden rounded bg-white shadows d-flex p-0">
        <div class="login-box">
          <div class="text-center">
            <img src="static/img/background/logo_gto_2.png" alt="declaraNet" class="gto-logo mb-5 mt-5">
            <!-- <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br> -->
            <p class="m-4 text-justify">Bienvenido al sistema de declaración de situación patrimonial y de intereses para servidores públicos del Poder Ejecutivo del Estado de Guanajuato.</p>
            <!-- <p class="m-4 text-justify bt">Secretaría de la Transparencia y Rendición de Cuentas del Estado de Guanajuato</p> -->
            <!-- <p>
              <a class="btn btn-login2" style="color: rgb(255, 255, 255) !important;
margin: 10px;
width: 242px !important;" href="https://declaranet2018.strc.guanajuato.gob.mx/" target="_blank">Presentación de declaración<br> Inicial y/o Final</a>
            </p> -->
          </div>
          <div>
          </div>
          <div class="login-img" style="background-image: url(static/img/background/bg_login_1.png) "></div>
        </div>
        <div class="mt-5 mb-5 mr-auto ml-auto ">
          <form method="#" action="#">
            <div v-if="recupera_vista">
              <div class="text-center">
                <img src="static/img/background/declaranet_logo.png" alt="declaraNet" class="d-logo mb-3">
              </div>
              <div class="d-flex campo">
                <div class="icon mt-auto mr-2 mb-2"><i class="fas fa-user align-text-bottom"></i></div>
                <div class="field mb-2">
                  <input type="text" v-model="rfc_recupera" name="rfc_recupera" id="rfc_recupera" placeholder="RFC" class="rfc">
                  <label for="email" class="mr-auto">RFC</label>
                </div>
              </div>
              <div class="d-flex campo mb-4">
              </div>
              <div class="text-center mb-3">
                <button type="button" @click="recupera_pass()" class="btn btn-login">Recuperar</button>
              </div>
              <div class="text-center">
                <a href="#" v-on:click="recupera_pass_cancel_vista">Regresar a login</a>
              </div>
            </div>
            <div v-else>
              <div class="text-center">
                <img src="static/img/background/declaranet_logo.png" alt="declaraNet" class="d-logo mb-3">
              </div>
              <div class="d-flex campo">
                <div class="icon mt-auto mr-2 mb-2"><i class="fas fa-user align-text-bottom"></i></div>
                <div class="field mb-2">
                  <input type="email" v-model="correo" name="email" id="email" placeholder="RFC" class="rfc" v-on:keyup.enter="login()">
                  <label for="email" class="mr-auto">RFC</label>
                </div>
              </div>
              <div class="d-flex campo mb-4">
                <div class="icon mt-auto mr-2 mb-2"><i class="fas fa-unlock-alt"></i></div>
                <div class="field mb-2">
                  <input type="password" v-model="pass" name="password" id="password" placeholder="CONTRASEÑA" v-on:keyup.enter="login()">
                  <label for="password" class="mr-auto">Contraseña</label>
                </div>
              </div>
              <div class="text-center mb-3">
                <button type="button" @click="login()" v-on:keyup.enter="login()" class="btn btn-login">Iniciar sesión</button>
              </div>
              <div class="text-center">
                <a href="#" v-on:click="recupera_pass_vista">¿ Olvidaste tu contraseña ?</a>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="!loading" class="alert alert-danger  col-8 offset-2">
        <h3 class="text-center">Error cargando sesión</h3>
      </div>
    </div>
    <!-- <div class="form-group">
                      <label>RFC</label>
                      <input type="email"  placeholder="RFC" class="form-control input-no-border rfc">
                    </div>
                    <div class="form-group">
                      <label>Password</label>
                      <input type="password" v-model="pass" placeholder="Password" class="form-control input-no-border">
                    </div> -->
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  export default {
    data () {
      return {
        loading: true,
        correo: '',
        rfc_recupera: '',
        pass: '',
        recupera_vista: 0
      }
    },
    methods: {
      recupera_pass () {
        this.$http.get('recupera_pass/' + this.rfc_recupera).then(response => {
          // console.log(response.data);
          if (response.data.message) {
            this.$swal({
              title: 'Error',
              text: 'RFC no encontrado',
              type: 'error'
            })
          }
          if (response.data.email) {
            this.$swal({
              title: 'Info',
              // text: 'Se ha enviado un correo con su contraseña al siguiente correo electronico: ' + response.data.email + ' si este correo no le pertenece o no lo reconoce favor de comunicarse con el personal de recursos humanos.',
              html: 'Se enviara un correo electrónico con su contraseña a la siguiente dirección: <strong>' + response.data.email + '</strong>. Debido a la demanda de solicitudes esto puede tardar un par de horas, si este correo no le pertenece o no lo reconoce favor de comunicarse con el personal de recursos humanos.',
              // content: content,
              type: 'info',
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false
            })
          }
        }, error => {
          // this.loading = false;
          this.Err(error)
        /* this.$swal({
          title: 'Error',
          text: 'RFC no encontrado',
          type: 'error'
        }) */
        })
      },
      recupera_pass_cancel_vista () {
        this.recupera_vista = 0
      },
      recupera_pass_vista () {
        this.recupera_vista = 1
      },
      login () {
        // localStorage.clear();
        // this.checkedlog = Math.random();

        // var token = Vue.prototype.$jwt.hasToken();
        //   var jwt = '';
        //   if (token) {
        //     jwt = Vue.prototype.$jwt.decode();
        //   }

        if (localStorage.getItem('app-token-declaranet')) {
          console.log('ok')
          this.checkedlog = Math.random()
          localStorage.clear()
        } else {
          this.$http.get('login/' + this.correo + '/' + this.pass).then(response => {
            if (response.data.message) {
              this.$swal({
                title: 'Verifica',
                text: 'La información es incorrecta',
                type: 'warning'
              })
            } else {
              this.setSession(response.data)
              this.checkedlog = Math.random()
              if (response.data.pr) {
                // if (this.getKey('tipo_dec1') == 2){
                if (this.getKey('movimiento') == 0) {
                  this.$swal({
                    title: 'VERIFICA',
                    text: 'Estimado servidor público, por el momento este usuario esta inactivo consulta con tu área de recursos humanos.',
                    type: 'warning'
                  })
                } else {
                  this.$router.push('/update')
                // this.$router.go();
                }
              } else {
                /// /si inicia sesion correctamente y es administrador
                if (this.getKey('role') != 0) {
                  this.$router.push('/admin/tablero')
                // this.$router.go();
                } else { // si es declarante
                  // if (this.getKey('status_dec') == 1) {
                  //   this.$router.push('/forms/infPersonal');
                  // } else {
                  //   this.$router.push('/forms/enviada');
                  //   localStorage.setItem('std', 0);
                  // }
                  // this.checkCatalogs();
                  // this.$router.push('/forms/tablero')
                  // console.log(this.getKey('tipo_dec1'));
                  // if (this.getKey('tipo_dec1') == 2){
                  /* if (this.getKey('tipo_dec') === 'Anual'){
                    this.$swal({
                      title: 'AVISO IMPORTANTE ',
                      text: 'Estimado servidor público, por el momento solo podrás realizar tu declaración INICIAL y FINAL. Para la declaración patrimonial ANUAL consulta con tu área de recursos humanos la fecha en que podrás realizarla.',
                      type: 'warning',
                    })
                  }else{ */
                  if (this.getKey('movimiento') == 0) {
                    this.$swal({
                      title: 'VERIFICA',
                      text: 'Estimado servidor público, por el momento este usuario esta inactivo consulta con tu área de recursos humanos.',
                      type: 'warning'
                    })
                  }
                  /* else if (this.getKey('movimiento') == 2){
                                    this.$swal({
                                      title: 'VERIFICA',
                                      text: 'RFC NO ENCONTRADO',
                                      type: 'warning',
                                    })
                                  } */
                  else {
                    if (this.getKey('status_dec') == 1) {
                      this.$router.push('/forms/infPersonal')
                    // this.$router.go();
                    } else {
                      this.$router.push('/forms/enviada')
                      localStorage.setItem('std', 0)
                    }
                    this.checkCatalogs()
                    this.$router.push('/forms/tablero')
                    // this.$router.go();
                    // }
                  }
                }
                // this.$router.go();
              }
            }
          }, error => {
            this.loading = false
            this.Err(error)
          })
        }
      }
    },
    created () {
      if (navigator.userAgent.includes && (navigator.userAgent.toUpperCase().includes('TLSv1.2 ECDHE-RSA-AES128-GCM-SHA256') || navigator.userAgent.toUpperCase().includes('TLSv1.2 ECDHE-RSA-AES256-GCM-SHA384') || navigator.userAgent.includes('Version/12.1 Safari/605.1.15'))) {
        this.$swal({
          title: 'Alerta',
          text: 'Detectamos que estás usando un navegador no compatible, por favor usa Chrome o Mozilla',
          type: 'warning'
        })
      }
      if (this.checkedlog) {
        this.checkedlog = Math.random()
        localStorage.clear()
      }
    }
  }

</script>
<style>
  .rfc {
    text-transform: uppercase !important;
  }

  .shadows {
    /* box-shadow: 0 0.5rem 1rem rgba(25, 122, 167, 0.15) !important; */
    -webkit-box-shadow: 0px 10px 10px -5px rgba(33, 92, 194, 0.25) !important;
    -moz-box-shadow: 0px 10px 10px -5px rgba(33, 92, 194, 0.25) !important;
    box-shadow: 0px 10px 10px -5px rgba(33, 92, 194, 0.25) !important;
  }

  .login-box {
    width: 35% !important;
  }

  .login-box p {
    z-index: 100 !important;
    position: relative !important;
    color: #fff !important;
    font-size: 14px !important;
  }

  .login-box .bt {
    font-size: 12px !important;
    text-align: center !important;
    bottom: 0px !important;
    position: absolute !important;
    max-width: 268px !important;
    box-sizing: border-box !important;
  }

  .login-img {
    width: 35% !important;
    position: absolute !important;
    z-index: 0 !important;
    height: 100% !important;
    display: block !important;
    top: 0 !important;
    left: 0 !important;
    background-size: cover !important;
    background-position: center center !important;
  }

  .gto-logo {
    z-index: 100 !important;
    position: relative !important;
    margin-top: 45px !important;
    /* width: 100px !important; */
    width: 60% !important;
    /* display: block !important; */
  }

  .d-logo {
    width: 150px !important;
  }

  .campo {
    border-bottom: 1px solid #ccc !important;
  }

  .field {
    display: flex !important;
    flex-flow: column-reverse !important;
    min-width: 250px !important;
    /*  border-bottom: 1px solid #ccc !important !important; */
  }

  .login-container * label,
  .login-container * input {
    transition: all 0.2s !important;
    touch-action: manipulation !important;
  }

  .login-container * input,
  .login-container * input[type="text"] {
    border: 0 !important;
    border: none !important;
    font-family: inherit !important;
    -webkit-appearance: none !important;
    border-radius: 0 !important;
    padding: 0 !important;
    cursor: text !important;
  }

  .login-container * input:focus {
    outline: 0 !important;
    /* border-bottom: 1px solid #ccc !important; */
  }

  .login-container * label {
    text-transform: uppercase !important;
    margin-bottom: 0.25rem !important;
  }

  .login-container * input:placeholder-shown+label {
    cursor: text !important;
    max-width: 66.66% !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    transform-origin: left bottom !important;
    transform: translate(0, 1.55rem) scale(1) !important;
    color: #908d8b !important;
  }

  ::-webkit-input-placeholder {
    opacity: 0 !important;
    transition: inherit !important;
  }

  .login-container * input:focus::-webkit-input-placeholder {
    opacity: 1 !important;
    color: #c5c5c5 !important;
  }

  .login-container * input:not(:placeholder-shown)+label,
  .login-container * input:focus+label {
    transform-origin: left !important;
    transform: translate(0, 0.4rem) scale(.75) !important;
    color: #207cd6 !important;
    cursor: pointer !important;
  }

  .icon {
    color: #929292 !important;
  }

  .btn-login {
    width: 100% !important;
    border-radius: 0.5em !important;
    -webkit-box-shadow: 0 .25rem .5rem rgba(0, 123, 255, .35) !important;
    -moz-box-shadow: 0 .25rem .5rem rgba(0, 123, 255, .35) !important;
    box-shadow: 0 .25rem .5rem rgba(0, 123, 255, .35) !important;
    background: #162881 !important;
    background-image: linear-gradient(to right, #162881, #207cd6) !important;
    border: none !important;
    color: white !important;
    /* background-image: linear-gradient(to bottom right, #007bff, #25cdff) !important; */
    /* box-shadow: 0 .25rem .5rem rgba(0, 123, 255, .5) !important; */
  }

  .btn-login2 {
    background: #27ab84 !important;
    border: none !important;
    border-radius: .25rem !important;
  }

  .btn-login:hover {
    -webkit-box-shadow: 0 .25rem .5rem rgba(0, 123, 255, .65) !important;
    -moz-box-shadow: 0 .25rem .5rem rgba(0, 123, 255, .65) !important;
    box-shadow: 0 .25rem .5rem rgba(0, 123, 255, .65) !important;
    background-image: linear-gradient(to right, #2241dd, #1ea5ff) !important;
    color: white !important;
  }

  .login-container * a {
    color: #444873 !important;
  }

  body {
    background: linear-gradient(45deg,
        #f1f1f1 100%,
        #ebebeb 100%) !important;
  }

  /* .container {}

  @media (min-width: 576px) {
    .container {}
  } */
  body,
  html {
    /* text-align: center !important; */
    /* display: -ms-flexbox !important;
    display: -webkit-box !important;
    display: flex !important; */
    -ms-flex-pack: center !important;
    -webkit-box-pack: center !important;
    justify-content: center !important;
    height: 100% !important;
    width: 100% !important;
    flex-flow: row nowrap !important;
  }

  .container {
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    /* max-width: 42em !important; */
  }

  .pannel-box {
    box-sizing: border-box !important;
    padding: 20px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Login.vue